import { createContext } from 'react';
import { noop } from 'ramda-adjunct';
export const ConfirmDialogContext = createContext({
    props: {},
    setProps: noop,
    setOpen: noop,
});
//# sourceMappingURL=confirmDialogsContext.js.map